import { render, staticRenderFns } from "./AdvanceCollection.vue?vue&type=template&id=3c42a9bc&scoped=true&"
import script from "./AdvanceCollection.vue?vue&type=script&lang=js&"
export * from "./AdvanceCollection.vue?vue&type=script&lang=js&"
import style0 from "./AdvanceCollection.vue?vue&type=style&index=0&id=3c42a9bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c42a9bc",
  null
  
)

export default component.exports